import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';

import _cloneDeep from 'lodash/cloneDeep';
import _last from 'lodash/fp/last';
import _isNaN from 'lodash/fp/isNaN';

import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import intl from '../../../shared/intl';
import checkPermissions from '../../../shared/check-permissions';

import createGeneralForm from '../components/forms/general';

const mainForm = createGeneralForm({
	namespace: 'achievementEditor',
	stateNodeName: 'mainForm'
});

const TOGGLE_PROGRESS_BAR = 'achievementEditor/toggle-progress-bar';
const FETCH_ACHIEVEMENTS_SUCCESS = 'achievementEditor/fetch-applicant-success';
const FETCH_ERROR = 'achievementEditor/fetch-error';
const GET_EMPTY_DATA = 'achievementEditor/get-empty-data';
const SET_DATA_TO_NULL = 'achievementEditor/set-data-to-null';
const CATEGORIES_LOOKUP_SUCCESS = 'achievementEditor/categories-lookup-success';

export const allowedPermissions = {
	'view': 'achievements_view',
	'edit': 'achievements_update'
};

const initialState = {
	data: null,
	showProgressBar: false,
	mainForm: mainForm.initialState,
	error: false
};

const getTabLangs = currentLanguage => state => {
	const { defaultLanguage } = state.achievementsEditor;
	const langs = state.root.lists.languages;
	return langs.map(lang => ({
		...lang,
		isSelected: true,
		isActive: lang.id === currentLanguage,
		isDefault: lang.id === defaultLanguage
	}));
};

export const actions = Object.assign({
	fetchData: () => dispatch => {
		const { pathname } = window.location;
		let lastParams = parseInt(_last(pathname.split('/')));

		if (_isNaN(lastParams)) return setTimeout(() => dispatch(actions.getEmptyData()), 0);

		const request = http({
			url: `${endpoints.ACHIEVEMENTS.BASE}/${lastParams}`,
			method: 'get',
			actions: [ FETCH_ACHIEVEMENTS_SUCCESS, FETCH_ERROR ]
		});

		return request(dispatch);
	},

	setDataToNull: () => ({ type: SET_DATA_TO_NULL }),

	toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR }),

	getEmptyData: () => ({ type: GET_EMPTY_DATA}),

	locationsLookup: text => (dispatch, getState) => {

		const request = http({
			url: endpoints.LOOKUPS.LOCATIONS,
			method: 'get',
			actions: [CATEGORIES_LOOKUP_SUCCESS],
			query: { query: text }
		});

		return request(dispatch).then(action => {
			if (action.type === CATEGORIES_LOOKUP_SUCCESS) {
				return { options: action.payload.data.map(item => ({ value: item.id, label: item.text })) };
			}
		});
	}
},
mainForm.actions
);

const reducers = Object.assign({
	[GET_EMPTY_DATA]: (state, action) => ({
		...state,
		data: {},
		showProgressBar: false
	}),
	[SET_DATA_TO_NULL]: state => ({ ...state, data: null }),
	[LOCATION_CHANGE]: (state, action) => {
		return ({ ...state, data: null });
	},
	[FETCH_ACHIEVEMENTS_SUCCESS]: (state, action) => {
		return {
			...state,
			data: action.payload.data,
			showProgressBar: false
		};
	},
	[FETCH_ERROR]: state => ({ ...state, error: true, showProgressBar: false}),
	[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar })
},
mainForm.reducers
);

export default handleActions(reducers, _cloneDeep(initialState));

export const selectors = {
	getData: state => state.achievementsEditor.data,
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getProgressBar: state => state.achievementsEditor.showProgressBar,
	getMainFormData: mainForm.selectors.getMainFormData,
	getOfferCategoriesOptions: mainForm.selectors.getOfferCategoriesOptions,
	getStartPeriodOptions: mainForm.selectors.getStartPeriodOptions,
	getError: state => state.achievementsEditor.error,
	getMainTabLangs: state => {
		const { currentLanguage } = state.achievementsEditor.mainForm;
		return getTabLangs(currentLanguage)(state);
	},
	getCurrentLanguage: mainForm.selectors.getCurrentLanguage
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/missions/achievement/editor/index.js